import axios from 'axios';
import { ApiUrl } from '../services/ApiRest';
import React, { Component } from 'react'
import Cookies from 'universal-cookie';
import {
    NavLink as Link,
    withRouter
} from 'react-router-dom';

const cookie = new Cookies();
const urlAdministrativo = ApiUrl + "admins/";
const idAdministrativo = cookie.get("idAdministrativo");
class SidebarBienestar extends Component {

    componentDidMount() {
        // Get que devuelve los datos de un estudiante recibiendo un id
        axios.get(urlAdministrativo + idAdministrativo + "?api_key=7d3654c0-3d52-447c-8893-eda66cddfa71")
            .then(res => {
                const estudiante = res.data;
                this.setState({ estudiante });
                //console.log(estudiante);

                cookie.set('nombres', estudiante.nombres_administrativo, { path: "/" })
                cookie.set('apellidos', estudiante.apellidos_administrativo, { path: "/" })
            })
    }
    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            document.body.classList.remove("sb-sidenav-toggled");
        }
    }
    render() {
        return (
            <div id="layoutSidenav_nav" style={{ width: 226 }}>
            <nav className="sb-sidenav sb-sidenav-dark-custom accordion animate__animated animate__fadeInLeft" id="sidenavAccordion">
                <div className="sb-sidenav-menu px-2 pt-3">
                    <div className="sb-sidenav-menu-heading text-uppercase text-muted small mb-2">
                        <p className="text-white">PERSONAL BIENESTAR INSTITUCIONAL</p>
                    </div>

                    <Link to="/bienestar" className="nav-link-custom">
                        <i className="fas fa-home me-2"></i>
                        Página Principal A
                    </Link>

                    <div className="nav-section">
                        <div
                            className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseAdministrativo"
                            aria-expanded="false"
                        >
                            <span>
                                <i className="fa fa-comment-dollar me-2"></i> BECAS
                            </span>
                            <i className="fas fa-chevron-down small"></i>
                        </div>

                        <div className="collapse" id="collapseAdministrativo">
                            <nav className="nav flex-column ms-3">
                                <Link to="/Bienestar/EstCarreraCicloBecas" className="nav-sub-link">Asignar becas a estudiantes</Link>
                                <Link to="/Bienestar/EstudiantesBecasxPeriodo" className="nav-sub-link">Reporte de estudiantes con beca</Link>
                            </nav>
                        </div>
                    </div>

                    <div className="nav-section">
                        <div
                            className="nav-link-custom collapsed d-flex justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapsePerfil"
                            aria-expanded="false"
                        >
                            <span>
                                <i className="far fa-user me-2"></i> PERFIL
                            </span>
                            <i className="fas fa-chevron-down small"></i>
                        </div>

                        <div className="collapse" id="collapsePerfil">
                            <nav className="nav flex-column ms-3">
                                <Link to="/Bienestar/VerPerfilBienestar" className="nav-sub-link">Ver Perfil</Link>
                            </nav>
                        </div>
                    </div>
                </div>

                <div className="sb-sidenav-footer text-white bg-azul-light text-center py-3 small">
                    Usuario: <br />
                    {cookie.get("nombres")} {cookie.get("apellidos")}
                </div>
            </nav>
        </div>
        )
    }
}
export default withRouter(SidebarBienestar);
